module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright1",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt1"
  }, [_vm._v("The Daring Debutantes Bundle"), _c('br'), _vm._v("Copyright © 2015 Rosetta Books")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Henrietta copyright © 1979 by Marion Chesney"), _c('br'), _vm._v("Molly copyright © 1980 by Marion Chesney"), _c('br'), _vm._v("Penelope copyright © 1982 by Marion Chesney"), _c('br'), _vm._v("Lucy copyright © 1980 by Marion Chesney"), _c('br'), _vm._v("Annabelle copyright © 1980 by Marion Chesney"), _c('br'), _vm._v("Kitty copyright © 1979 by Marion Chesney"), _c('br'), _vm._v("Sally copyright © 1982 by Marion Chesney")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Electronic edition published 2015 by RosettaBooks"), _c('br'), _vm._v("Cover copyright © 2011 by RosettaBooks, LLC"), _c('br'), _vm._v("ISBN (EPUB): 9780795347801"), _c('br'), _vm._v("ISBN (Kindle): 9780795347986")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("www.RosettaBooks.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d230dbc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/cop.vue
// module id = 63
// module chunks = 0